<template>
	<div style="background: white">
		<policyHeader />
		<div class="breadBox">
			<a-breadcrumb>
				<span>
					<img src="@/assets/img/position.png" />
					当前位置：
				</span>
				<a-breadcrumb-item @click="onRollbackHome" style="cursor:pointer">首页</a-breadcrumb-item>
				<a-breadcrumb-item @click="onRollback" style="cursor:pointer">资讯公告</a-breadcrumb-item>
				<a-breadcrumb-item>活动报名详情</a-breadcrumb-item>
			</a-breadcrumb>
		</div>
		<div class="tabBox">
			<div class="detailTop">
				<span class="tipCon tipconOn" v-if="detailObj.isFinish == 1 && diffTime(detailObj.signendTime)"></span>
				<span class="tipCon" v-else></span>
				<img v-if="detailObj.logo" :src="getImg(detailObj.logo)" alt="">
				<img v-else src="@/assets/img/defaultPhotoLong.png" alt="">
				<div class="detailRight">
					<div class="baseName">{{ detailObj.title }}</div>
					<div class="time">报名时间:{{ detailObj.activityTime }} ~ {{ detailObj.signendTime }}</div>
					<div class="time">活动时间:{{ detailObj.startDate }} ~ {{ detailObj.endDate }}</div>
					<div class="baseAddress">地址:{{ detailObj.address }}</div>
					
				</div>
				<a-button class="activerybtn" v-if="detailObj.isFinish == 1 && diffTime(detailObj.signendTime)"
						@click="baoming()">活动报名</a-button>
					<a-button class="activerybtn" style="background: #ccc" v-else-if="detailObj.isFinish != 0 &&!diffTime(detailObj.signendTime)">活动报名结束</a-button>
					<a-button class="activerybtn" style="background: #ccc" v-if="detailObj.isFinish == 0">活动结束</a-button>
				<div class="collect" @click="onCollect(detailObj.title)" v-if="!collectShow">
					<StarOutlined />
					收藏
				</div>
				<div class="collect" @click="oncancel" v-if="collectShow">
					<StarOutlined />
					已收藏
				</div>
			</div>
			<div class="detailBottom">
				<div class="introduce">
					<div class="title">活动介绍</div>
					<div class="content" v-html="detailObj.content"></div>
				</div>
				<div class="other">
					<div class="title">活动推荐</div>
					<div v-for="item in baseList.splice(0, 2)" :key="item.id" class="imageTitle">
						<span class="tipCon tipconOn" v-if="item.isFinish == 1 && diffTime(item.signendTime)"></span>
			<span class="tipCon" v-else></span>
						<img v-if="item.logo" :src="getImg(item.logo)" alt="" @click="onImgUrl(item.id)">
						<img v-else src="@/assets/img/defaultPhotoLong.png" alt="" @click="onImgUrl(item.id)">
					</div>
				</div>
			</div>
		</div>
		<LayoutFooter />
	</div>
	<a-modal width="600px" title="活动报名" v-model:visible="visible" :maskClosable="false" :closable="false" @ok="onSubmit"
		@cancel="handleCancel">
		<a-form :labelCol="{ span: 6 }" layout="horizontal" ref="ruleForm" :model="form" :rules="rules" @submit="onSubmit">
			<a-row :gutter="[24, 8]">
				<a-col :span="24">
					<div class="hidden">
						<a-form-item label="id" name="id">
							<a-input v-model:value="form.id" />
						</a-form-item>
						<a-form-item label="活动id" name="activityId">
							<a-input v-model:value="form.activityId" placeholder="请输入活动id" />
						</a-form-item>
					</div>
					<a-form-item :labelCol='{ span: 6 }' label="报名人姓名" name="name">
						<a-input v-model:value="form.name" placeholder="请输入报名人姓名" />
					</a-form-item>
					<a-form-item :labelCol='{ span: 6 }' label="报名人电话" name="phone">
						<a-input v-model:value="form.phone" placeholder="请输入报名人电话" />
					</a-form-item>
					<a-form-item :labelCol='{ span: 6 }' label="预计报名人数" name="applyNum">
						<a-inputNumber style="width: 100%;" v-model:value="form.applyNum" placeholder="请输入" />
					</a-form-item>
				</a-col>
			</a-row>
		</a-form>
	</a-modal>
</template>
<script>
import dataCheck from "@/utils/dataCheck";
import LayoutFooter from '@/layout/layoutPage/footer/LayoutFooterNew2'
import { formMixin } from "@/mixins";
import { activity, collectWeb, volumeWeb } from "@/api/innovationService";
import { file_service } from "@/api/adminService";
import policyHeader from "./policyHeader"
import { message } from "ant-design-vue";

export default {
	name: "policyDetail",
	mixins: [formMixin],
	components: {
		LayoutFooter, policyHeader
	},
	data() {
		return {
			detailObj: {},
			baseList: [],
			collectShow: false,
			visible: false,
			activityId: "",
			form: {
				id: null,
			},
			rules: {
				id: [],
				activityId: [],
				name: [dataCheck.required({})],
				phone: [dataCheck.required({}),dataCheck.mobile_phone],
				applyNum: [dataCheck.required({ type: 'number' })]
			}
		}
	},
	computed: {
		submitUrl() {
			return activity.save
		}
	},
	watch: {
		activityId(val) {
			if (val) {
				this.getDetail(this.activityId)
				this.getSignup()
			}
		}
	},
	created() {
		this.activityId = this.$route.query.id
		this.form.activityId = this.activityId
		this.getDetail(this.activityId)
	},
	mounted() {

		this.getvolume()
		this.getSignup()
		if (this.$ls.get('token')) {
			this.getIsCollect()
		}
	},
	methods: {
		diffTime(endtime) {
			let now = new Date() //当前时间
			//如果传2022-02-22 14:15:00要转化成 2022/02/22 14:15:00
			let end = new Date(endtime.replace(/-/g, "/")) //对比时间
			if (now.getTime() > end.getTime()) {
				//当前时间比指定时间大
				return false
			} else {
				//小于指定时间
				return true
			}
		},
		onImgUrl(id) {

			this.getDetail(id)
			this.getSignup()
		},
		getImg(imgUrl) {
			return file_service.imagesWeb(imgUrl)
		},
		getDetail(id) {
			this.getAction({
				url: activity.detail,
				params: { id: id }
			}).then(res => {
				this.detailObj = res
			})
		},
		oncancel() {
			this.postAction({
				url: collectWeb.romver,
				params: {
					urls: window.location.href,
					systemType: 'innovation'
				}
			}).then(() => {
				message.success("取消收藏")
				this.getIsCollect()
			})
		},
		getIsCollect() {
			this.getAction({
				url: collectWeb.Iscancel,
				params: {
					urls: window.location.href,
					systemType: 'innovation'
				}
			}).then(res => {
				this.collectShow = res
			})
		},
		getSignup() {
			this.getAction({
				url: activity.pageList,
				params: {
					systemType: "innovation"
				}
			}).then(res => {
				this.baseList = res.records
			})

		},
		getvolume() {
			this.postAction({
				url: volumeWeb.saveVisits,
				params: {
					type: 3,
					name: "innovation"
				}
			})
		},
		onCollect(title) {
			if (this.$ls.get('token')) {
				let collUrl = window.location.href
				this.postAction({
					url: collectWeb.saveOrUpdate,
					params: {
						title: title,
						type: "5",
						url: collUrl,
						systemType: 'innovation'
					}
				}).then(() => {
					message.success("收藏成功")
					this.getIsCollect()
				})
			} else {
				message.success("登录后可以操作");
				this.$router.push({ path: '/login', query: { id: 'user' } })
			}
		},
		onRollback() {
			this.$router.push({
				path: "/Innovation/components/consultation",
				query: {
					type: "资讯公告",
					activeKey: "3"
				}
			})
		},
		onRollbackHome() {
			this.$router.push({
				path: "/Innovation/index",
				query: {
					type: "首页"
				}
			})
		},
		baoming() {
			if (this.$ls.get('token')) {
				this.visible = true;
				this.form.name = null
				this.form.phone = null
				this.form.applyNum = null
			} else {
				message.success("登录后可以操作");
				this.$router.push({ path: '/login', query: { id: 'user' } })
			}
		},
		handleOk() {
			this.visible = false;
		},
	}
}
</script>
<style scoped lang="less">
.breadBox {
	width: 1200px;
	margin: 0 auto;
	padding: 20px 0;
	background: white;
}

.tabBox {
	width: 1200px;
	margin: 0 auto;
	padding: 10px 0 20px 0;
	position: relative;
	.tipCon{
		position: absolute;
		top:-2px;
		left:-2px;
		width:55px;
		height:55px;
		background: url(../../../assets/img/signendOff.png);
	}
	.tipconOn{
		background: url(../../../assets/img/signendOn.png);
	}
	.detailTop {
		background: #edf0f7;
		padding: 20px;
		display: flex;
		position: relative;

		img {
			width: 304px;
			height: 207px;
		}

		.detailRight {
			margin-left: 30px;
			padding-top: 20px;

			.baseName {
				font-size: 20px;
			}

			.time {
				font-size: 14px;
				color: #666;
				margin-top: 10px;
			}

			.baseAddress {
				font-size: 14px;
				color: #666;
				margin-top: 10px;
			}

			
		}
		.activerybtn {
			// width: 100px;
			height: 40px;
			color: white;
			background: #2162e4;
			border: none;
			margin-top: 20px;
			position: absolute;
			right: 60px;
			padding:5px 40px;
			cursor: pointer
		}
		.collect {
			
			border:1px solid #2162e4;
			padding:5px 0;
			text-align: center;
			width:135px;
			color:#2162e4;
			font-size: 16px;
			position: absolute;
			border-radius: 5px;
			right: 60px;
			top:100px;
			cursor: pointer;
		}
	}

	.detailBottom {
		display: flex;
		margin-top: 20px;
		justify-content: space-between;

		.introduce {
			width: 70%;

			.title {
				width: 70px;
				font-size: 16px;
				border-bottom: 2px solid #2162e4;
				font-weight: 800;
			}

			.content {
				font-size: 16px;
				line-height: 30px;
				margin-top: 20px;
				text-indent: 30px;
			}
		}

		.other {
			width: 27%;

			.title {
				width: 70px;
				font-size: 16px;
				border-bottom: 2px solid #2162e4;
				font-weight: 800;
			}

			.imageTitle {
				margin-top: 20px;
				position: relative;

				img {
					width: 304px;
					height: 171px;
				}
			}
		}
	}
}
</style>
